
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M55.999 32c-3.168-4.917-7.135-8.593-11.907-11.031A13.649 13.649 0 0145.998 28c0 3.855-1.37 7.15-4.109 9.891-2.74 2.74-6.036 4.11-9.89 4.11-3.854 0-7.151-1.37-9.89-4.11-2.741-2.74-4.11-6.036-4.11-9.89 0-2.522.635-4.866 1.906-7.032-4.77 2.438-8.74 6.114-11.906 11.032 2.77 4.27 6.245 7.67 10.422 10.202 4.176 2.532 8.703 3.798 13.577 3.798 4.876 0 9.401-1.266 13.579-3.798 4.177-2.531 7.651-5.932 10.422-10.202zM33.06 21.064c.292-.291.438-.646.438-1.062 0-.417-.146-.772-.438-1.063a1.448 1.448 0 00-1.063-.438c-2.604 0-4.838.932-6.702 2.797-1.865 1.865-2.798 4.1-2.798 6.703 0 .417.146.772.438 1.063.291.292.646.438 1.062.438.417 0 .772-.146 1.063-.438.292-.291.438-.646.438-1.063 0-1.792.634-3.322 1.906-4.593 1.27-1.271 2.802-1.906 4.593-1.906.417 0 .771-.146 1.063-.438zm26.313 8.78c.416.73.624 1.449.624 2.158 0 .708-.208 1.427-.624 2.156-2.917 4.791-6.839 8.63-11.766 11.515C42.681 48.558 37.478 50 31.998 50c-5.478 0-10.682-1.448-15.609-4.343-4.926-2.896-8.849-6.73-11.765-11.5-.417-.73-.626-1.448-.626-2.156 0-.71.21-1.428.626-2.157 2.916-4.77 6.839-8.604 11.765-11.5C21.316 15.448 26.52 14 32 14s10.682 1.448 15.61 4.344c4.926 2.896 8.848 6.73 11.765 11.5z","fill-rule":"nonzero"}})])
          )
        }
      }
    